import { Button, Col, Form, FormInstance, Input, InputNumber, Modal, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import FormLabel from "src/components/AntdCustomPart/FormLabel/FormLabel";
import ModalTitle from "src/components/AntdCustomPart/ModalTitle/ModalTitle";
import { SettingEmissionControlTank } from "src/entity/settings/tank";
import { generateErrorMessage } from "src/utils/error-message";
import { onKeyDownNumberWithFixedDecimal } from "src/utils/key-down-validate";
import { formatNumber } from "src/utils/process-number";

const { Text } = Typography;

const TankEmissionControlModal = (props: {
  form: FormInstance;
  open: boolean;
  loading: boolean;
  mode: "insert" | "update";
  isDuplicate: boolean;
  onDuplicateChange: (isDup: boolean) => void;
  onCloseModal: () => void;
  onSave: (mode: "insert" | "update", data: SettingEmissionControlTank) => void;
}) => {
  const precision = 2;
  const { form, loading, open, mode, isDuplicate, onDuplicateChange, onCloseModal, onSave } = props;
  const [errorDuplicate, setErrorDuplicate] = useState<string | null>(null);

  const handleSave = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      onSave(mode, values);
    } catch (error) {
      console.error(error);
    }
  };

  const onChangeForm = (changeValue: any) => {
    Object.keys(changeValue).forEach((key) => {
      if (["efficiency"].includes(key)) {
        if (changeValue[key] && changeValue[key] > 100) {
          form.setFieldsValue({
            [key]: 100,
          });
        }
      }
    });
    if (["emissionControl", "efficiency"].some((key) => changeValue[key])) {
      onDuplicateChange(false);
    }
  };

  useEffect(() => {
    const errorText = isDuplicate ? "Emission Control and Efficiency already exists in the system." : "";
    setErrorDuplicate(errorText);
    form.setFields(
      ["emissionControl", "efficiency"].map((field) => ({
        name: field,
        errors: isDuplicate ? [""] : [],
      })),
    );
  }, [isDuplicate]);

  return (
    <div>
      <Modal
        centered
        maskClosable={false}
        open={open}
        onCancel={onCloseModal}
        width={700}
        title={<ModalTitle title="Emission Control" />}
        footer={
          <Row className="w-full border-t" justify={"end"}>
            <Button className="mt-4" key="submit" type="primary" loading={loading} onClick={handleSave}>
              Save
            </Button>
          </Row>
        }
      >
        {errorDuplicate && (
          <>
            <Row className="w-full" justify={"center"}>
              <Text type="danger">{errorDuplicate}</Text>
            </Row>
          </>
        )}
        <Form size="middle" layout="vertical" autoComplete="off" form={form} requiredMark={false} onValuesChange={onChangeForm}>
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} lg={12}>
              <Form.Item
                label={<FormLabel label={"Emission Control"} required />}
                name="emissionControl"
                rules={[{ required: true, message: generateErrorMessage("Emission Control") }]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} lg={12}>
              <Form.Item
                label={<FormLabel label={"Efficiency"} required />}
                name="efficiency"
                rules={[{ required: true, message: generateErrorMessage("Efficiency") }]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  max={100}
                  addonAfter={"%"}
                  onKeyDown={(e) => {
                    onKeyDownNumberWithFixedDecimal(e, precision);
                  }}
                  formatter={(value) => formatNumber(value as number, precision)}
                />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item label={<FormLabel label={"Remark"} />} name="remark">
                <Input.TextArea rows={3}></Input.TextArea>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default TankEmissionControlModal;
